import { api } from "./config";

export const saveContactUs = async (data) => {
  try {
    const res = await api.post("contact-us/save", data);
    return res;
  } catch (error) {
    return error.response;
  }
};